export const purple = {
  50: 'hsla(292, 44%, 93%, 1)',
  100: 'hsla(291, 46%, 83%, 1)',
  200: 'hsla(291, 47%, 71%, 1)',
  300: 'hsla(291, 47%, 60%, 1)',
  400: 'hsla(291, 47%, 51%, 1)',
  500: 'hsla(291, 64%, 42%, 1)',
  600: 'hsla(287, 65%, 40%, 1)',
};

export type PurplePalette = typeof purple;
